export default "__VITE_ASSET__HQR2PTxQ__"